interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showTagline?: boolean;
}

export function Logo({ size = 'md', showTagline = true }: LogoProps) {
  const iconSize = size === 'sm' ? 'w-10 h-10' : size === 'lg' ? 'w-14 h-14' : 'w-12 h-12';
  const svgSize = size === 'sm' ? 'w-6 h-6' : size === 'lg' ? 'w-8 h-8' : 'w-7 h-7';
  const titleSize = size === 'sm' ? 'text-2xl' : size === 'lg' ? 'text-4xl lg:text-5xl' : 'text-3xl lg:text-4xl';

  return (
    <div className="flex items-center gap-4">
      <div className={`${iconSize} rounded-lg bg-primary-500 flex items-center justify-center`}>
        <svg
          className={`${svgSize} text-white`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 4v4a1 1 0 001 1h4"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 13h6M9 17h4"
          />
        </svg>
      </div>
      <div>
        <h1 className={`${titleSize} font-bold text-white tracking-tight`}>
          Distyll
        </h1>
        {showTagline && (
          <p className="text-surface-400 text-sm mt-0.5">
            Turn anything into notes that actually work
          </p>
        )}
      </div>
    </div>
  );
}
